import { ShieldCheck, SealCheck, FilePdf, HeartStraight } from "@phosphor-icons/react";

const certs = [
  {
    id: "nasm-cpt",
    primary: "NASM",
    secondary: "CPT",
    line: "NCCA-accredited Certified Personal Trainer",
    type: "Certification",
    proof: "https://customer-assets.emergentagent.com/job_slay-aesthetic-boost/artifacts/sy42n23k_33a2cc80-6431-4aeb-a761-cc6757761a8b.pdf",
    icon: SealCheck,
  },
  {
    id: "nfpt-cpt",
    primary: "NFPT",
    secondary: "CPT",
    line: "National Federation of Professional Trainers",
    type: "Certification",
    proof: null,
    icon: SealCheck,
  },
  {
    id: "nasm-cnc",
    primary: "NASM",
    secondary: "CNC",
    line: "Certified Nutrition Coach",
    type: "Certification",
    proof: "https://customer-assets.emergentagent.com/job_slay-aesthetic-boost/artifacts/hnj13yiu_9dbfcac2-be22-4549-aa18-88b023bf1956.pdf",
    icon: SealCheck,
  },
  {
    id: "cpr-aed",
    primary: "CPR",
    secondary: "/ AED",
    line: "Adult · Child · Infant — ASTI",
    type: "Life-saving",
    proof: "https://customer-assets.emergentagent.com/job_slay-aesthetic-boost/artifacts/dccj9fxh_6f8ab0dd-3fd1-419d-b628-1f316f17f6a1.pdf",
    icon: HeartStraight,
  },
  {
    id: "ergonext",
    primary: "ERGO",
    secondary: "Next",
    line: "Liability insurance · Fully covered",
    type: "Insured",
    proof: null,
    icon: ShieldCheck,
    insured: true,
  },
];

export default function Credentials() {
  return (
    <section
      id="credentials"
      data-testid="credentials-section"
      className="relative px-6 md:px-12 lg:px-20 py-16 lg:py-20 border-b border-white/10 bg-[#070707]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 mb-10">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-[#FF1B91]" />
            <p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold">
              Fully certified · Fully insured
            </p>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-white/45 md:text-right">
            Click any card to view the actual credential
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 border border-white/10">
          {certs.map((c, i) => {
            const Icon = c.icon;
            const Wrapper = c.proof ? "a" : "div";
            const linkProps = c.proof
              ? { href: c.proof, target: "_blank", rel: "noreferrer noopener" }
              : {};
            return (
              <Wrapper
                key={c.id}
                {...linkProps}
                data-testid={`cred-${c.id}`}
                className={`group relative p-6 lg:p-7 flex flex-col items-start gap-4 transition-all duration-300 hover:bg-[#FF1B91]/[0.04] ${
                  i < certs.length - 1 ? "border-r border-white/10" : ""
                } border-b lg:border-b-0 border-white/10 ${
                  c.proof ? "cursor-pointer" : "cursor-default"
                }`}
              >
                <div className="flex items-center gap-2.5 w-full">
                  <Icon
                    size={18}
                    weight="fill"
                    className="text-white/30 group-hover:text-[#FF1B91] transition-colors flex-shrink-0"
                  />
                  <span className="text-[9px] uppercase tracking-[0.3em] font-semibold text-white/45 group-hover:text-[#FF1B91] transition-colors">
                    {c.type}
                  </span>
                </div>

                <div className="flex items-baseline gap-1.5 flex-wrap">
                  <span className="font-display font-black text-2xl lg:text-3xl text-white/85 group-hover:text-white transition-colors tracking-tighter leading-none">
                    {c.primary}
                  </span>
                  <span className="font-brush text-[#FF1B91]/70 group-hover:text-[#FF1B91] text-lg lg:text-xl leading-none transition-colors">
                    {c.secondary}
                  </span>
                </div>

                <p className="text-[11px] text-white/45 group-hover:text-white/70 transition-colors leading-relaxed flex-1">
                  {c.line}
                </p>

                {c.proof ? (
                  <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] font-bold text-white/40 group-hover:text-[#FF1B91] transition-colors">
                    <FilePdf size={12} weight="bold" /> View cert →
                  </span>
                ) : (
                  <span className="text-[10px] uppercase tracking-[0.25em] font-semibold text-white/30">
                    Verifiable on request
                  </span>
                )}
              </Wrapper>
            );
          })}
        </div>

        <p className="mt-6 text-center text-[11px] uppercase tracking-[0.25em] text-white/35">
          All certifications NCCA-aligned ·{" "}
          <a
            href="https://www.nasm.org/"
            target="_blank"
            rel="noreferrer noopener"
            data-testid="nasm-verify-link"
            className="text-[#FF1B91]/70 hover:text-[#FF1B91] transition-colors underline underline-offset-4 decoration-[#FF1B91]/30"
          >
            NASM.org
          </a>{" "}
          · Cert IDs available on request
        </p>
      </div>
    </section>
  );
}
